import { SxStyles } from '../../../../../../types';
import theme from '../../../../../../theme';
import { getResponsiveSize } from '../../../../../../utils';

export const PsylarisDetailPopperStyle: SxStyles = {
  psylarisDetailPopper: {
    '& .detail-card': {
      ml: getResponsiveSize(10),
      width: getResponsiveSize(350),
      borderRadius: getResponsiveSize(12),
      padding: getResponsiveSize(20),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      '& .detail-title-container': {
        mb: getResponsiveSize(6),
        display: 'flex',
        justifyContent: 'flex-start',
        '& .detail-title': {
          fontFamily: theme.typography.mainFontFamily,
          fontSize: getResponsiveSize(16),
          minHeight: 0,
          minWidth: 0,
          padding: 0,
          color: theme.palette.neutral?.grey70,
          fontWeight: '700',
        },
      },
      '& .detail-content-container': {
        display: 'flex',
        justifyContent: 'center',
        '& .detail-content': {
          fontFamily: theme.typography.mainFontFamily,
          fontSize: getResponsiveSize(13),
          minHeight: 0,
          minWidth: 0,
          padding: 0,
          color: theme.palette.neutral?.grey70,
          fontWeight: '400',
        },
      },

      '& .detail-image-container': {
        borderRadius: getResponsiveSize(5),
        mb: getResponsiveSize(18),

        '& .detail-image': {
          borderRadius: getResponsiveSize(5),
        },
        '& video': {
          borderRadius: theme.palette.propVars?.borderRadius,
          pt: getResponsiveSize(1),
        },
      },
    },
  },
};
